<template>
  <admin-layout title="Testes Bigfive" menu="Testes">
    <title>Bigfive</title>
    <div class="row mt-3">
      <div class="col-lg-2 col-12"></div>
      <div class="col-lg-8">
        <h4 class="block_header">CADASTRO DE TESTE BIGFIVE</h4>
      </div>
      <div class="col-lg-2 col-xs-12"></div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-2"></div>
      <div class="col-lg-8 col-xs-12">
        <div id="new-job-box ">
          <div class="card mt-3">
            <div class="card-body formJov">
              <div class="row">
                <div class="col-lg-6 col-12">
                  <inputform
                    v-model="bigfive.name"
                    type="text"
                    label="Título do teste"
                    :field="$v.bigfive.name"
                    class="label-bold"
                  />
                </div>
                <div class="col-lg-6 col-12">
                  <label><strong>DATA PARA TÉRMINO </strong></label>
                  <Datepicker
                    input-class="form-control"
                    class="p-0"
                    :format="formatFns"
                    placeholder=""
                    v-model="bigfive.date_end"
                    :language="ptBR"
                  ></Datepicker>
                </div>
                <div class="col-lg-6 col-12">
                  <label> <strong>TIPO DE TESTE</strong> </label><br />
                  <label class="mr-3">
                    <input type="radio" v-model="bigfive.status" :value="1" />
                    PRIVADO
                  </label>
                  <label>
                    <input type="radio" v-model="bigfive.status" :value="0" />
                    PÚBLICO
                  </label>
                </div>
                <div class="col-lg-6 col-12">
                  <label> <strong>QUANTIDADE DE PERGUNTAS</strong> </label
                  ><br />
                  <label class="mr-3">
                    <input
                      type="radio"
                      v-model="bigfive.amount_itens"
                      :value="120"
                    />
                    120 ITENS
                  </label>
                  <label>
                    <input
                      type="radio"
                      v-model="bigfive.amount_itens"
                      :value="50"
                    />
                    50 ITENS
                  </label>
                </div>
              </div>

              <div v-if="bigfive.status == 1">
                <VueTagsInput
                  placeholder="Adicionar emails"
                  v-model="emails_current"
                  :tags="invited"
                  @tags-changed="(newTags) => (invited = newTags)"
                />
                <span class="f12"
                  >PRESSIONE 'ENTER' PARA ADICIONAR MAIS EMAILS</span
                >
              </div>
              <div class="row mt-3">
                <div class="col-lg-12 col-12" v-if="url != ''">
                  <p
                    class="pointer mt-3 mb-3 color-grey"
                    v-clipboard:copy="url"
                    v-clipboard:success="onCopy"
                  >
                    <font-awesome-icon icon="paperclip" />
                    {{ url }}
                  </p>
                </div>
                <div class="col-lg-6 col-xs-12">
                  <button
                    :disabled="load"
                    @click="save()"
                    type="buttom"
                    class="btn mt-3 full btn-degrade normal-degrade"
                  >
                    <font-awesome-icon v-show="!load" icon="check" />
                    {{ !load ? "Salvar Teste" : "" }}
                    <div
                      v-show="load"
                      class="spinner-border text-light"
                      role="status"
                    >
                      <span class="sr-only"></span>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <inertia-link href="/recruiters/assessments/bigfives">
            <font-awesome-icon class="mr-2" icon="chevron-left" />
            VOLTAR
          </inertia-link>
        </div>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import format from "date-fns/format";

import { required, minLength, email } from "vuelidate/lib/validators";

import VueTagsInput from "@johmun/vue-tags-input";
import { ptBR } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";
export default {
  props: ["bigfive_attr"],
  components: { VueTagsInput, Datepicker },
  data: () => ({
    ptBR: ptBR,
    load: false,
    emails_current: "",
    invited: [],
    url: "",
    id: 0,
    bigfive: {
      date_end: new Date(),
      name: "",
      status: 1,
      amount_itens: 120,
      invited: [],
    },
  }),

  mounted() {
    if (this.bigfive_attr) {
      this.bigfive = {
        name: this.bigfive_attr.name,
        status: this.bigfive_attr.status ? 1 : 0,
        date_end: this.formatFns(this.bigfive_attr.date_end),
        amount_itens: this.bigfive_attr.amount_itens
          ? this.bigfive_attr.amount_itens
          : 120,
        invited: [],
      };
      this.id = this.bigfive_attr.id;
      this.url = this.bigfive_attr.url;
      if (this.bigfive_attr.invited) {
        let emails = JSON.parse(this.bigfive_attr.invited);
        for (let i = 0; i < emails.length; i++) {
          this.invited.push({
            text: emails[i],
            tiClasses: ["ti-valid"],
          });
        }
      }
    }
  },
  methods: {
    formatFns(date) {
      return format(new Date(date), "dd/MM/yyyy");
    },
    onCopy: function (e) {
      this.$toast.success("LINK COPIADO COM SUCESSO");
    },
    save() {
      this.load = true;
      let emails = [];
      if (this.invited.length != 0) {
        for (let i = 0; i < this.invited.length; i++) {
          emails.push(this.invited[i].text);
        }
      }
      this.bigfive.invited = emails;
      this.$v.bigfive.$touch();
      if (this.$v.bigfive.$error) {
        this.$toast.error("PREENCHA CORRETAMENTE OS CAMPOS PARA CONTINUAR");
        this.load = false;
        return;
      }
      if (this.id == 0) {
        axios
          .post("/recruiters/assessments/bigfives", {
            bigfive: {
              date_end: format(new Date(this.bigfive.date_end), "yyyy-MM-dd"),
              name: this.bigfive.name,
              status: this.bigfive.status,
              amount_itens: this.bigfive.amount_itens,
              invited: this.bigfive.invited,
            },
          })
          .then((response) => {
            this.url = response.data.url;
            this.$toast.success("TESTE CADASTRADO COM SUCESSO");
            this.load = false;
          })
          .catch((error) => {
            this.load = false;
          });
      } else {
        axios
          .put("/recruiters/assessments/bigfives/" + this.id, {
            bigfive: this.bigfive,
          })
          .then((response) => {
            this.url = response.data.url;
            this.$toast.success("TESTE ATUALIZADO COM SUCESSO");
            this.load = false;
          })
          .catch((error) => {
            this.load = false;
          });
      }
    },
  },
  validations: {
    bigfive: {
      name: { required, minLength: minLength(4) },
    },
    emails_current: { email },
  },
};
</script>

<style>
</style>